import { createReducer } from 'typesafe-actions';

import { IAdvancedRoleState } from '@/features/roles/store/models/accessControl.model';
import { RolesActionValues, TRolesActions } from '@/features/roles/store/types/roles.types';

const initialState: IAdvancedRoleState = {
  value: undefined,
  error: undefined,
  isLoading: false,
};

export const AdvancedRoleReducer = createReducer<IAdvancedRoleState, TRolesActions>(initialState)
  .handleType(RolesActionValues.GET_ROLE_SUCCESS, (state, action) => {
    return {
      ...state,
      value: action.role,
      error: undefined,
      isLoading: false,
    };
  })
  .handleType(RolesActionValues.GET_ROLE_FAILED, (state, action) => ({
    ...state,
    value: undefined,
    error: action.error,
    isLoading: false,
  }));
